module.exports = __webpack_public_path__ + "media/images/stock_groups/e86c-81448c09e9fa6ff4d19c6ffe29dd0ac0.svg";